import { SVGProps } from "react";

export const SmallChevronToggleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.6465 7.60429L6 4.957786L3.3535 7.60429L2.6465 6.89729L5.293 4.250786C5.48053 4.063315 5.73484 3.958 6 3.958C6.26516 3.958 6.51947 4.063315 6.707 4.250786L9.3535 6.89729L8.6465 7.60429Z"
      fill="#706A85"
    />
  </svg>
);
